import styled from "styled-components";

export const PageContainer = styled.div`
    width: 100%;
    padding: 2.5rem;
    box-sizing: border-box;
    background-color: #f8f9fa;
`;

export const Header = styled.header`
    margin-bottom: 2rem;
    h1 {
        font-size: 2.5rem;
        color: #212529;
        margin: 0 0 0.5rem 0;
    }
    p {
        font-size: 1.1rem;
        color: #6c757d;
        margin: 0;
    }
`;

export const FilterContainer = styled.div`
    background: #ffffff;
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    margin-bottom: 2rem;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 1.5rem;
`;

export const FilterGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 250px;
    
    label {
        font-size: 0.875rem;
        font-weight: 500;
        color: #495057;
    }

    select, input {
        height: 48px;
        border: 1px solid #ced4da;
        border-radius: 8px;
        padding: 0 1rem;
        font-size: 1rem;
        background-color: #f8f9fa;
        color: #495057;
        &:focus {
            outline: none;
            border-color: #80bdff;
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }
    }
`;

export const FilterButton = styled.button`
    height: 48px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0 2rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
        background: #0069d9;
    }
`;